import { createFileRoute } from '@tanstack/react-router';
import { PriceCalculatorSubscriptionsOverview } from '@uturn/portal/modules/price-calculator/pages/subscriptions';

export const Route = createFileRoute('/_protected/calculator/subscriptions')({
	component: PriceCalculatorSubscriptionsOverview,
});
